<template lang="pug">
.not-found
  h1 404
  h2 {{ $t('pageNotFound') }}
  h3 {{ $t('pageNotFoundDescription') }}
  KetchUpButton.primary(@click.native='router.push("/")')
    h5 {{ $t('returnToHomepage') }}
</template>

<script setup lang="ts">
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import { useRouter } from 'vue-router/composables'

  const router = useRouter()
</script>

<style lang="postcss" scoped>
  .not-found {
    @apply ketch-flex ketch-flex-col ketch-space-y-c15 ketch-items-center ketch-justify-center ketch-text-center ketch-p-c20;

    button {
      @apply ketch-w-auto;
    }
  }
</style>
